/**<params config data>说明
 * position 文本框位置：string  left  right  top  bottom
 * isShowLogo 控制 EcoFlow logo 显示
 * titleFontSize 标题字号
 * desFontSize 简介字号
 * theme 决定文本跟logo颜色：white black
 */
import Image from '@/components/UI/Image';
import BsFillTriangleFill from '@/components/UI/svg/Icons/BsFillTriangleFill';
import IoMdCloseCircle from '@/components/UI/svg/Icons/IoMdCloseCircle';
import { getImageLocal } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
const configs = {
    position: 'top',
    isShowLogo: true,
    titleFontSize: 80,
    desFontSize: 28,
    theme: 'white',
    isShowVideo: false,
    height: 0,
    isWebp: false,
    webpUrl: '',
};

const itemsData = [
    {
        bgImgs: '/img/banner-delta.png',
        title: 'RIVER',
        suffix: '',
        des: 'Live without limits with the portable home battery',
        video_src: 'https://www.youtube.com/embed/ozVzv0jo_BM',
    },
];

export default function BannerModule({ config, data = itemsData }: any) {
    const configTypes = { ...configs, ...config };
    const { useState, useLang, useRouter, gtm } = useGlobal();
    const { EFPic } = createEFPic(configTypes?.webpUrl);
    const { t } = useLang('product');
    const { t: s } = useLang('shared');
    const { locale } = useRouter();
    const logoImgLocal = getImageLocal(locale, ['cn']);
    const [floatVideo, setFloatVideo] = useState(false);
    const [curVideo, setCurVideo] = useState(data[0]?.video_src);

    const toggleVideo = (url: string) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: data.title,
            position: data.title,
        });
        setFloatVideo(!floatVideo);
        if (!url) setCurVideo(url);
    };

    return (
        <div className={css.BannerModule}>
            {data.map((item: any) => (
                <div
                    className="box"
                    key={item.title}
                    style={{
                        height: configTypes.height || (configTypes.position === 'left' || configTypes.position === 'right' ? '900px' : '1080px'),
                    }}
                >
                    <div
                        className="bg"
                        style={{
                            height: configTypes.height || (configTypes.position === 'left' || configTypes.position === 'right' ? '900px' : '1080px'),
                        }}
                    >
                        {configTypes.isWebp || Array.isArray(item.bgImgs) ? (
                            <EFPic
                                name={item.bgImgs}
                                className="fullImgs"
                                alt={`${item.title}${item.suffix ? ` ${item.suffix}` : ''}`}
                                aria-label={`${item.title}${item.suffix ? ` ${item.suffix}` : ''}`}
                            />
                        ) : (
                            <Image
                                src={item.bgImgs}
                                layout="fill"
                                className="fullImgs"
                                priority
                                alt={`${item.title}${item.suffix ? ` ${item.suffix}` : ''}`}
                                aria-label={`${item.title}${item.suffix ? ` ${item.suffix}` : ''}`}
                            />
                        )}
                    </div>
                    <div
                        className={
                            configTypes.position == 'top'
                                ? 'container topPosition'
                                : configTypes.position == 'left'
                                ? 'container leftPosition'
                                : 'container bottomPosition'
                        }
                    >
                        <div
                            className="content"
                            style={{
                                textAlign: configTypes.position === 'left' || configTypes.position === 'right' ? 'left' : 'center',
                                marginBottom: configTypes.position === 'bottom' ? (configTypes.isShowVideo ? '90px' : '140px') : 'initial',
                                marginTop: configTypes.position === 'top' ? (configTypes.isShowVideo ? '140px' : '160px') : 'initial',
                            }}
                        >
                            <span style={{ display: configTypes.isShowLogo ? 'block' : 'none' }}>
                                <Image
                                    src={configTypes.theme === 'white' ? `/img/logo_white_${logoImgLocal}.png` : `/img/logo_black_${logoImgLocal}.png`}
                                    width={locale === 'cn' ? 214 : 177}
                                    height={19}
                                    alt={t('logo')}
                                />
                            </span>
                            <div
                                className="title font-family-bold"
                                style={{
                                    fontSize: `${configTypes.titleFontSize}px`,
                                    color: configTypes.theme === 'white' ? '#fff' : '#000',
                                }}
                            >
                                {item.title}{' '}
                                <p className="suffix font-family-regular" style={{ display: item.suffix ? '' : 'none' }}>
                                    {item.suffix}
                                </p>
                            </div>
                            <p
                                className="des font-family-semibold"
                                style={{
                                    fontSize: `${configTypes.desFontSize}px`,
                                    color: configTypes.theme === 'white' ? '#fff' : '#000',
                                    marginTop: configTypes.position === 'left' || configTypes.position === 'right' ? '38px' : '18px',
                                }}
                            >
                                {item.des}
                            </p>
                            {configTypes.isShowVideo && (
                                <button
                                    id="btnWatchVideo"
                                    onClick={() => toggleVideo(item.video_src)}
                                    className="videoButton"
                                    aria-label={t('Watch video')}
                                    style={{
                                        color: configTypes.theme === 'white' ? '#fff' : '#000',
                                        borderColor: configTypes.theme === 'white' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.7)',
                                        marginTop: '48px',
                                    }}
                                >
                                    <div>Watch video</div>
                                    <BsFillTriangleFill className="arrow-triangle-right" />
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            ))}
            {floatVideo && (
                <div className="youtubeVideo">
                    <IoMdCloseCircle className="closeIcon" onClick={() => toggleVideo('')} />
                    <iframe
                        width="840"
                        height="472"
                        src={curVideo}
                        title={s('youtube_video_player')}
                        frameBorder="0"
                        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    ></iframe>
                </div>
            )}
        </div>
    );
}
